module.exports = __webpack_public_path__ + "img/v-m-4.9966128b.jpg";